import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProductModel } from 'Pages/orders'
import { RequestParams, ResponseCatalog, ProductRecommendationModel } from 'Models'

type productsState = {
	recommendations: ResponseCatalog<ProductRecommendationModel>
	products: ResponseCatalog<ProductModel>
}

export const productsInitialState: productsState = {
	recommendations: new ResponseCatalog<ProductRecommendationModel>(),
	products: new ResponseCatalog(),
}

export namespace ProductsNS {
	export type getRecommendations = PayloadAction<{ okved: string; rbidos_type: string }>
	export type setRecommendations = PayloadAction<ResponseCatalog<ProductRecommendationModel>>
	export type clearRecommendations = PayloadAction

	export type getProducts = PayloadAction<RequestParams>
	export type setProducts = PayloadAction<ResponseCatalog<ProductModel>>
	export type clearProducts = PayloadAction
}

export const productsSlice = createSlice({
	name: 'products',
	initialState: productsInitialState,
	reducers: {
		getRecommendations: (state, action: ProductsNS.getRecommendations) => {},
		setRecommendations: (state, action: ProductsNS.setRecommendations) => {
			state.recommendations = action.payload
		},
		clearRecommendations: (state, action: ProductsNS.clearRecommendations) => {
			state.recommendations = null
		},

		getProducts: (state, action: ProductsNS.getProducts) => {},
		setProducts: (state, action: ProductsNS.setProducts) => {
			state.products = action.payload
		},
		clearProducts: (state, action: ProductsNS.clearProducts) => {
			state.recommendations = null
		},
	},
})
